module.exports = __webpack_public_path__ + "static/media/trihydro.1c4734e6.png";